<template>
    <div style="height:100%">
        <el-container style="height: 100%;width: 100%">
            <el-header>
               <!-- <div style="text-align: left;float: left; padding-left: 8%;width:40%" v-if="!isCollapse">
                    <el-switch v-model="isCollapse">
                    </el-switch>
                </div>
                <div style="text-align: left; float: left; padding-left: 1%;width:40%" v-if="isCollapse">
                    <el-switch v-model="isCollapse">
                    </el-switch>
                </div>-->
                <el-row style="display: flex">
                    <el-col :span="8">
                        <div style="width:186px;height:30px;background-color: #2564e4; padding-top: 15px;padding-left: 10px; display: flex">
                            <img src="@/assets/images/logo_white.png" />
                        </div>
                    </el-col>
                    <el-col :span="16">
                        <div style="text-align: right;float: right; padding-right: 1%; width:140px; padding-top: 20px; height: 60px">
                            <el-popover
                                    placement="bottom"
                                    trigger="hover"
                                    >
                                <el-link type="primary" v-on:click="changeLanguage('zh')" style="display: block;"><span style="font-size: 16px!important;" class="icon iconfont icon-kuaidiwuliu"></span> 简体中文</el-link>
                                <el-link type="primary" v-on:click="changeLanguage('en')" style="display: block;"><span style="font-size: 16px!important;" class="icon iconfont icon-kuaidiwuliu"></span> English</el-link>
                                <!--<el-link v-if="otherSystem" icon="el-icon-s-promotion" style="display: block;" type="primary" v-on:click="changeSystem()">{{$t('common.changeTo')}}{{systemName}}</el-link>-->
                                <el-link v-if="otherSystem" icon="el-icon-s-promotion" style="display: block;" type="primary" v-on:click="changeSystem()">{{systemName}}</el-link>
                                <el-link v-if="loginFlag === '1'" icon="el-icon-s-tools" style="display: block;" type="primary" v-on:click="changePass()">{{$t('common.changePass')}}</el-link>
                                <!--<el-link icon="el-icon-picture-outline-round" style="display: block;" type="primary" v-on:click="showImageClick()">{{$t('common.operationFlow')}}</el-link>-->
                                <el-link class="exit" icon="el-icon-error" type="primary" style="display: block;" v-on:click="exitSystem()">{{$t('common.exit')}}</el-link>
                                <!--<el-link icon="el-icon-user-solid" slot="reference" type="info" style="margin-right: 20px">{{$t('common.user')}}</el-link>-->
                                <el-link icon="el-icon-user-solid" slot="reference" type="info" style="margin-right: 20px">{{currentUserName}}</el-link>
                            </el-popover>
                        </div>
                        <div style="font-size: 14px;text-align: right;float: right; padding-right: 1%; width:21%; padding-top: 20px; height: 60px;color: #fff;">
                            {{$t('common.currentSystem')}} : {{currentSystemName}}
                        </div>
                        <div style="font-size: 14px;text-align: right;float: right; padding-right: 1%; width:16%; padding-top: 20px; height: 60px;color: #fff;">
                            <a @click="showImageClick" style="cursor: pointer;">{{ $t("login.processImage") }}</a>
                        </div>
                        <div style="font-size: 14px;text-align: right;float: right; padding-right: 1%; width:20%; padding-top: 20px; height: 60px;color: #fff;">
                            <a @click="openImageAgreement = true" style="cursor: pointer;">{{ $t("login.agreementImage") }}</a>
                        </div>
                    </el-col>
                </el-row>
                <Header></Header>
            </el-header>
            <el-container>
                <el-aside width=null>
                    <!--消除滚动条-->
                    <!-- <el-scrollbar style="height: 100%;width: 100%"> -->
                    <el-menu :unique-opened="true" :collapse="isCollapse" router :default-active="active" :style="{'--width': menuWidth}" class="myMenu">
                        <NavMenu ref="menu" :navMenus="menuData"></NavMenu>
                    </el-menu>
                    <!-- </el-scrollbar> -->
                </el-aside>
                <el-container class="contentBody">
                    <!-- 引入面包屑 -->
                    <Breadcrumb ref="breadCrumb"></Breadcrumb>
                    <el-main class="childViewBody">
                        <router-view />
                    </el-main>
                    <el-footer style="text-align: center;line-height:32px;padding: 15px 50px;">
                        <!-- 引入底部组件 -->
                        <Footer></Footer>
                    </el-footer>
                </el-container>
            </el-container>
        </el-container>

        <!-- 新增业务57:流程图页面  start -->
        <el-dialog
            :visible.sync="openImage"
            width="500px"
            :show-close="false"
            center>
                <el-image
                    style="width: 100%; max-height: 700px"
                    :src="url"
                    :preview-src-list="srcList">
                </el-image>
        </el-dialog>
        <!-- 新增业务57:流程图页面  end -->
        <!-- 提单协议图片 -->
        <el-dialog
                :visible.sync="openImageAgreement"
                width="500px"
                :show-close="false"
                top="60px">
            <el-image
                    style="width: 100%; max-height: 700px"
                    :src="urlAgreement"
                    :preview-src-list="srcListAgreement">
            </el-image>
        </el-dialog>
    </div>
</template>
<script>
    import NavMenu from "./NavMenu.vue";
    import Footer from "./Footer";
    import Header from "./Header";
    import Breadcrumb from "./Breadcrumb";

    import {resetRouter} from '@/router/index'
    import jwt_decode from 'jwt-decode'

    export default {
        components: {
            NavMenu: NavMenu,
            Footer: Footer,
            Breadcrumb: Breadcrumb,
            Header: Header
        },
        inject: ["reloadRoot"],
        name: 'Layout',
        props: {},
        data() {
            return {
                // 面包屑数据源
                currentPath: [],
                // 菜单是否折叠
                isCollapse: false,
                // 菜单数据源
                menuData: null,
                // 另一个系统的名称
                systemName: '',
                // 当前系统名称
                currentSystemName: '',
                otherSystem: sessionStorage.getItem("otherSystem"),
                currentSystem: sessionStorage.getItem('currentSystem'),
                loginFlag: sessionStorage.getItem('loginFlag'),
                currentUserName: jwt_decode(sessionStorage.getItem("token")).userName,
                active: null,
                // (57) 使用参数 -start
                openImage: false,
                url: require('../assets/images/operation_flow.png'),
                srcList: [ require('../assets/images/operation_flow.png') ],
                // (57) 使用参数 -end
                openImageAgreement: false,
                urlAgreement: require('../assets/images/agreement.jpg'),
                srcListAgreement: [require('../assets/images/agreement.jpg')],
                menuWidth: "200px"
            };
        },
        created() {
            this.changeSystemName();
            this.changeMenuLanguage();
            this.refreshActive(this.$route);
            // resetRouter();
        },
        watch:{
            '$route' (route){
                this.refreshActive(route);
            }
        },
        methods: {
            changeSystem: function () {
                const currentSystem = sessionStorage.getItem('currentSystem');
                const otherSystem = sessionStorage.getItem('otherSystem');
                sessionStorage.setItem('currentSystem', otherSystem);
                sessionStorage.setItem('otherSystem', currentSystem);
                resetRouter();
                this.$router.push('/').catch(()=>{});
                this.$router.push('/home').catch(()=>{});
                this.reloadRoot();
                // window.location.reload();
            },
            exitSystem: function () {
                this.$axios.post('/api/sso/tokenlogout').then(response => {
                    console.log(response)
                });
                sessionStorage.removeItem('currentSystem');
                sessionStorage.removeItem('otherSystem');
                sessionStorage.removeItem('allMenu');
                if(jwt_decode(sessionStorage.getItem("token")).customerCompanyCnName === 'WIFFA'){
                    this.$router.push('/wlogin');
                }else{
                    this.$router.push('/');
                }
            },
            changeLanguage: function(locale){
                sessionStorage.setItem('locale', locale);
                for(let i=0; i<2; i++){
                    this.$i18n.locale = locale;
                    // 更换面包屑语言
                    this.$refs.breadCrumb.getBreadList();
                    // 更换切换系统语言
                    this.changeSystemName();
                    // 更换菜单语言
                    this.changeMenuLanguage();
                    resetRouter();
                }
            },
            changeSystemName: function(){
                if (this.$i18n.locale.indexOf('en') !== -1) {
                    // 修改菜单宽度
                    this.menuWidth = "300px";
                    this.systemName = this.otherSystem ? JSON.parse(this.otherSystem).enName: null;
                    this.currentSystemName = JSON.parse(this.currentSystem).enName;
                }else{
                    // 修改菜单宽度
                    this.menuWidth = "200px";
                    this.systemName = this.otherSystem ? JSON.parse(this.otherSystem).zhName: null;
                    this.currentSystemName = JSON.parse(this.currentSystem).zhName;
                }
            },
            changeMenuLanguage: function(){
                const routes = this.$router.options.routes;
                routes.forEach(item => {
                    if (item.path === '/Layout') {
                        this.menuData = [...item.children];
                        this.changeTitle(this.menuData);
                    }
                });
            },
            changeTitle: function(menuData){
                for (var i in menuData) {
                    const item = menuData[i];
                    if (this.$i18n.locale.indexOf('en') !== -1) {
                        item.meta.title = item.meta.enTitle;
                    }else{
                        item.meta.title = item.meta.zhTitle;
                    }
                    if (item.children) {
                        this.changeTitle(item.children);
                    }
                }
            },
            changePass(){
                this.$router.push('/change-pass')
            },
            refreshActive(route){
                // 如果有icon, 是菜单
                if(route.meta.icon){
                    this.active = route.path;
                }
            },
            showImageClick() {
                this.openImage = true;
            }
        }
    };
</script>

<style>
    .el-header {
        background-color: #2564e4;
        text-align: center;
        /*padding: 10px 50px;*/
        box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 4px 0px;
        margin-bottom: 0px;
        padding: 0;
    }

    .el-main {
        color: #333;
        text-align: center;
    }

    .el-aside {
        min-height: 858px;
    }

    .el-menu {
        height: 100%;
        background-color: #2564e4;
    }

    .el-submenu__title, .el-menu-item{
        color: #ffffff
    }

    .el-submenu__title i, .el-menu-item i{
        color: #ffffff
    }

    .el-menu-item.is-active {
        color: gold;
    }

    /*.el-menu:not(.el-menu--collapse) {*/
    /*    width: 200px;*/
    /*}*/
    .myMenu {
      width: var(--width);
    }

    .el-submenu .el-submenu__title:hover{
        border-left: #33A2EF solid 6px !important;
        background-color: #E2EFF9 !important;
        color: #38B2FF !important;
    }

    .el-menu-item:hover{
        border-left:#33A2EF solid 6px !important;
        background-color: #E2EFF9 !important;
        color: #38B2FF !important;
    }

    .contentBody{
        padding:0 20px;
        background: #fafafa;
        width: 100%;
    }

    .childViewBody{
        background: #fff;
        box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 4px 0px;
    }

    html, body, #app{
        margin: 0;
        height: 100%
    }

    /*.el-popover{*/
    /*    width: 80px;*/
    /*    min-width: 80px;*/
    /*}*/

    /deep/ .el-link{
        display: inline
    }

    .exit i{
        font-size: 14px!important;
    }

</style>
